<template>
    <div>
        <div class="modal-header">
            <button type="button" class="close" @click="hideModal()" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">Utwórz danie</h4>
        </div>
        <div class="modal-body">
            <food-edit :food="food" :mode="'create'" ref="foodEdit">
                <template slot="multi_portion_food_portion_amount">
                    <div class="clearfix"/>
                    <div class="col-xs-2 text-left mt-3">
                        <label class="control-label" for="portionAmount">Ilość</label>
                    </div>
                    <div class="col-xs-2 mt-3">
                        <input type="number"
                               class="form-control form-control-xs"
                               id="portionAmount"
                               :min="food.isMultiPortionFood() ? 1 : 0.1"
                               :step="0.5"
                               :max="food.isMultiPortionFood() ? food.portions : 999"
                               v-bind:value="food.portion.amount"
                               v-on:input="getPortionAmountOnInputListener(food, $event)"
                               v-on:change="getPortionAmountOnChangeListener($event)"
                        >
                    </div>
                </template>
            </food-edit>
        </div>
        <div class="modal-footer">
            <slot name="prevModal"></slot>
            <loading-button :loading="isLoading" :status="status" @click="storeOrUpdate">
                <i class="fa fa-save"></i>
                Dodaj i zapisz do mojej bazy
            </loading-button>
        </div>
    </div>
</template>

<style scoped>
    .in {
        display: block;
    }

    .products-table {
        font-size: 13px;
    }
</style>
<script>
    import {mapGetters, mapMutations, mapState} from 'vuex';

    import {productFactory} from '../../../factory/product.factory';
    import {foodFactory} from "../../../factory/food.factory";
    import uuid from "uuid4";
    import {Portion} from "../../../model/portion.model";
    import {trans} from "../../../app";
    import {FoodService} from "../../../services/FoodService";

    export default {
        data() {
            return {
                food: null,
                day: null,
                isLoading: false,
                status: '',
            };
        },
        computed: {
            ...mapState({
                modalData: state => state.modal.data,
                schema: state => state.menu.schema,
                modals: state => state.modals,
            }),
            ...mapGetters([
                'getDayById',
                'configuration',
            ])
        },
        methods: {
            ...mapMutations([
                'hideModal',
                'showModal',
            ]),
            remove(productId) {
                this.food.removeProduct(productId);
            },
            addProduct(product) {
                this.food.addProduct(productFactory.createFromDto(product));
            },
            getPortionAmountOnInputListener(food, $event) {
                const inputValue = Number($event.target.value);
                const minValue = Number($event.target.min);
                const maxValue = Number($event.target.max);

                if (inputValue >= minValue && inputValue <= maxValue) {
                    food.portion.amount = inputValue;
                } else if (inputValue < minValue) {
                    food.portion.amount = minValue;
                } else if (inputValue > maxValue) {
                    food.portion.amount = maxValue;
                }
            },
            getPortionAmountOnChangeListener($event) {
                const inputValue = Number($event.target.value);
                const minValue = Number($event.target.min);
                const maxValue = Number($event.target.max);

                if (inputValue >= minValue && inputValue <= maxValue) {
                    $event.target.value = inputValue;
                } else if (inputValue < minValue) {
                    $event.target.value = $event.target.min
                } else if (inputValue > maxValue) {
                    $event.target.value = $event.target.max;
                }
            },
            async storeOrUpdate(update = false) {
                this.$refs.foodEdit.validateFood();
                if (!this.food.isValid()) {
                    return;
                }

                this.isLoading = true;
                try {
                    this.food.regenerateHash();

                    const foodWeight = this.food.getTotalWeight();

                    this.food.portion = new Portion(this.food.portion.amount, foodWeight);


                  if (update) {
                    this.food = await FoodService.updateFood(this.food);
                  } else {
                    this.food = await FoodService.storeFood(this.food);
                  }

                    this.status = true;
                    this.$toasted.global.success({message: 'Danie zostało zapisane'});
                    this.plan.addFood(this.food);

                    this.modals.pop();
                    this.showModal(this.modals.pop());
                } catch (error) {
                    this.status = false;
                    if (error.response && error.response.status === 409) {
                        if (error.response.data.food_uuids.length === 1) {
                          this.$dialog.confirm(trans('app.food_already_exists_in_database_update'))
                              .then(() => {
                                this.food.externalId = error.response.data.food_uuids[0];
                                this.storeOrUpdate(true)
                              })
                              .catch(()=>{
                                this.status = '';
                              })
                        } else {
                          this.$toasted.global.info({message: trans('app.food_already_exists_in_database') });
                        }
                    } else {
                        this.$toasted.global.error({message: 'Danie nie zostało zapisane'});
                        this.sentryCaptureException(error);
                    }
                }

                this.isLoading = false;
            },
        },
        watch: {
            modalData: {
                immediate: true,
                handler: function (data) {
                    if (!data) return;
                    this.day = this.getDayById(data.dayId);
                    this.plan = this.day.getPlan(data.planId);
                    this.food = foodFactory.create(
                        uuid(),
                        null,
                        '',
                        1,
                        null,
                        null,
                        [],
                        null,
                        ''
                    )
                },
            },
        },
    };
</script>
